import queryString from 'query-string';

export const processUrlParameters = (windowUrl: string): any => {
  const urlParameters = queryString.parse(windowUrl);
  if (urlParameters.params) {
    try {
      return JSON.parse(atob(decodeURIComponent(urlParameters.params)));
    }
    catch (e) {
      // TODO: not sure how we want to handle this...
      return null;
    }
  }
};